import validate from "/home/runner/_work/mito-ui/mito-ui/node_modules/.pnpm/nuxt@3.18.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.3.0_@vue+compiler_d53acd4494f3e27b4dc18233304eda88/node_modules/nuxt/dist/pages/runtime/validate.js";
import maintenance_45global from "/home/runner/_work/mito-ui/mito-ui/middleware/maintenance.global.ts";
import route_45change_45global from "/home/runner/_work/mito-ui/mito-ui/middleware/route-change.global.ts";
import trailling_45slash_45global from "/home/runner/_work/mito-ui/mito-ui/middleware/trailling-slash.global.ts";
import manifest_45route_45rule from "/home/runner/_work/mito-ui/mito-ui/node_modules/.pnpm/nuxt@3.18.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.3.0_@vue+compiler_d53acd4494f3e27b4dc18233304eda88/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  maintenance_45global,
  route_45change_45global,
  trailling_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "is-dev-mode": () => import("/home/runner/_work/mito-ui/mito-ui/middleware/is-dev-mode.ts"),
  "is-master-contract-owner": () => import("/home/runner/_work/mito-ui/mito-ui/middleware/is-master-contract-owner.ts"),
  "is-owner": () => import("/home/runner/_work/mito-ui/mito-ui/middleware/is-owner.ts")
}